import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../images/logowithnamewhite.png';

const Footer = () => {
  return (
    <footer className="site-footer">
      <img src={logo} alt="Teamward" />

      <p>
        The easiest way to discover and plan unforgettable team experiences.
      </p>

      <div className="footer-links">
        <Link to="/">Home</Link>
        <a href="/brief.html">The Team Event Brief</a>
        <Link to="/terms-conditions">Terms</Link>
        <Link to="/privacy">Privacy</Link>
        <a href="mailto:mkuhl@teamward.ai">Contact</a>
      </div>
    </footer>
  );
};

export default Footer;
